import React, { useState } from 'react';
import NavBar from '../navbar/navBarComponent';
import Title from '../title-tile/titleTileComponent';
import PaintOrdersTable from './paintOrdersTable';
import PaintOrdersAddForm from './paintOrderAddForm';
import paintOrderService from '../../utils/paint-orders';

let errorArray = [];

const PaintOrdersForm = (props) => {
  const [error, setError] = useState(null);
  const [paintOrders, setPaintOrders] = useState([]);

  const [disabled, setDisabled] = useState(false);
  const [success, setSuccess] = useState(false);

  /**
   * Method to save the paint orders
   * @returns {boolean}
   */
  const savePaintOrders = () => {
    // If there are errors show and return
    if (errorArray.length > 0) {
      setError(errorArray);
      return;
    }
    setDisabled(true);
    setError([]);

    // Save the paint orders
    paintOrderService.savePaintOrders({
      paintOrders: paintOrders
    })
      .then((response) => {
        if (response.success) {
          setSuccess(true);
          setDisabled(false);
          setPaintOrders([]);
        } else {
          setDisabled(false);
        }
      })
      .catch((error) => {
        setError([error.message]);
        setDisabled(false);
      });
  };

  /**
   * Validates if all the fields are included
   */
  const validateCreate = () => {
    let isValid = true;
    if (errorArray.length > 0) isValid = false;
    if (!paintOrders.length) isValid = false;
    return isValid;
  };

  const generateGeneralError = (errorList) => {
    const errorRender = [];
    if (errorList) {
      for (let i = 0; i < errorList.length; i++) {
        errorRender.push(
          <li key={i} className="error-signup-general">
            {errorList[i]}
          </li>
        );
      }
    }
    return errorRender;
  };

  const deletePaintOrders = (index) => {
    const newOrderList = paintOrders.filter((elem, i) => i !== index);
    setPaintOrders([...newOrderList]);
  };

  return (
    <div>
      <NavBar />
      <div className="auth-wrapper bg-light">
        <div className="form-news">
          <form>
            <PaintOrdersAddForm paintOrders={paintOrders} setPaintOrders={setPaintOrders} user={props.user} />
            <PaintOrdersTable paintOrders={paintOrders} delete={deletePaintOrders} />
            <button
              type="button"
              className="btn btn-dark btn-block btn-save"
              onClick={savePaintOrders}
              disabled={!validateCreate() || disabled}
            >
              Guardar Ordenes
            </button>
            <ul className="error-list-general">
              {generateGeneralError(error)}
            </ul>
          </form>
          <div
            className="success-signup form-width"
            style={{ display: success ? 'block' : 'none' }}
          >
            <Title
              message="Las ordenes se guardaron correctamente!"
              theme="success"
            />
            <a
              className="btn btn-dark btn-block btn-save"
              href="/paint-capacity"
              role="button"
            >
              Volver
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintOrdersForm;
